exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VideoExercise-module__video-wrapper___MQYHR{aspect-ratio:16/9;width:100%;height:60vh;max-height:100%}", ""]);

// exports
exports.locals = {
	"video-wrapper": "VideoExercise-module__video-wrapper___MQYHR"
};